var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart-component"},[_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.barData,"height":_vm.barHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }